const CSRF_COOKIE = "csrf_token";
const CSRF_HEADER = "X-CSRF-Token";
const MUTATION_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

const BASE = (import.meta.env.BASE_URL ?? "/").replace(/\/$/, "");
const CSRF_ENDPOINT = `${BASE}/api/auth/csrf`;

let bootstrapPromise: Promise<string | null> | null = null;

function readCsrfCookie(): string | null {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${CSRF_COOKIE}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
}

export function getCsrfHeaders(method: string): Record<string, string> {
  if (!MUTATION_METHODS.has(method.toUpperCase())) return {};
  const token = readCsrfCookie();
  if (!token) return {};
  return { [CSRF_HEADER]: token };
}

export function isMutationMethod(method: string): boolean {
  return MUTATION_METHODS.has(method.toUpperCase());
}

export function isSameOriginRequest(input: RequestInfo | URL): boolean {
  try {
    const url =
      typeof input === "string"
        ? new URL(input, window.location.origin)
        : input instanceof URL
          ? input
          : new URL((input as Request).url, window.location.origin);
    return url.origin === window.location.origin;
  } catch {
    return true;
  }
}

export function getCsrfTokenFromCookie(): string | null {
  return readCsrfCookie();
}

export async function ensureCsrfToken(force = false): Promise<string | null> {
  if (!force) {
    const existing = readCsrfCookie();
    if (existing) return existing;
  }
  if (!bootstrapPromise) {
    bootstrapPromise = (async () => {
      try {
        await fetch(CSRF_ENDPOINT, {
          method: "GET",
          credentials: "include",
          cache: "no-store",
        });
      } catch {
        // network errors here are non-fatal — return whatever we can read
      }
      const token = readCsrfCookie();
      bootstrapPromise = null;
      return token;
    })();
  }
  return bootstrapPromise;
}
